"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('attachmentPreferencesOption', {
    fromComputer: null,
    fromOneDrive: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/store/store.js
// module id = 3061
// module chunks = 2